import { getColumnsTable as sbomTabGetColumnsTable } from "@/pages/DiscoveryPage/components/organisms/SbomTab/getColumnsTable"

export const getColumnsTable = sbomTabGetColumnsTable
